// extracted by mini-css-extract-plugin
export var buttons = "_be-0";
export var buttonsActive = "_be-h";
export var cancelConfirm = "_be-1";
export var closeButton = "_be-2";
export var column = "_be-3";
export var container = "_be-4";
export var detailHeader = "_be-6";
export var detailTitle = "_be-7";
export var detailsContent = "_be-5";
export var header = "_be-8";
export var headerWithClose = "_be-9";
export var icon = "_be-a";
export var infoIcon = "_be-c";
export var informationContainer = "_be-b";
export var sideDrawer = "_be-d";
export var sideDrawerOpen = "_be-e";
export var stickyFooter = "_be-f";
export var typeOption = "_be-g";